import LinkIcon from "@/common/images/icons/link.svg?react";
import EmbedIcon from "@/common/images/icons/embed.svg?react";
import RedditIcon from "@/components/icons-socials/reddit.svg?react";
import TwitterIcon from "@/components/icons-socials/twitter.svg?react";
import DiscordIcon from "@/components/icons-socials/discord.svg?react";
import StackIcon from "@/common/images/icons/stack.svg?react";

export const getShareMenuItems = (onShareClick: (label: string) => void, isGifPublished: boolean, userIsAuthenticated: boolean) => {
  return [
    {
      groupName: null,
      groupMobileName: null,
      items: [
        {
          icon: LinkIcon,
          title: "Copy Link",
          onClick: () => onShareClick("Copy Link")
        },
        {
          icon: EmbedIcon,
          title: "Embed",
          onClick: () => onShareClick("Embed")
        },
        ...(userIsAuthenticated ? [{
          icon: StackIcon,
          title: "Add to Niche",
          disabled: !isGifPublished,
          onClick: () => onShareClick("Add to Niche")
        }] : [])
      ]
    },
    {
      groupName: "Social Share",
      groupMobileName: "Social Share",
      className: "socialShare",
      items: [
        {
          icon: RedditIcon,
          className: "socialItem",
          title: "Reddit",
          onClick: () => onShareClick("Reddit")
        },
        {
          icon: TwitterIcon,
          className: "socialItem",
          title: "X",
          onClick: () => onShareClick("Twitter")
        },
        {
          icon: DiscordIcon,
          className: "socialItem",
          title: "Discord",
          onClick: () => onShareClick("Discord")
        }
      ]
    }
  ];
};
